(() => {
  if (window.LalaRecentProducts) return;

  const STORAGE_PREFIX = 'lalaRecentlyViewedProducts:v2:';
  const MAX_PRODUCTS = 6;
  const validVariantId = (value) => /^\d+$/.test(String(value || ''));

  const readProducts = (locale) => {
    try {
      const saved = JSON.parse(localStorage.getItem(`${STORAGE_PREFIX}${locale}`) || '[]');
      return Array.isArray(saved)
        ? saved.filter((item) => item && item.handle && item.title && validVariantId(item.variantId))
        : [];
    } catch (error) {
      return [];
    }
  };

  const writeProduct = (product) => {
    if (!product || !product.locale || !product.handle || !product.title || !validVariantId(product.variantId)) return;

    try {
      const products = readProducts(product.locale).filter((item) => item.handle !== product.handle);
      products.unshift({
        id: product.id,
        handle: product.handle,
        title: product.title,
        variantId: String(product.variantId),
        image: product.image || '',
        price: product.price || '',
        available: product.available === true
      });
      localStorage.setItem(`${STORAGE_PREFIX}${product.locale}`, JSON.stringify(products.slice(0, MAX_PRODUCTS)));
    } catch (error) {
      // Storage can be unavailable in private browsing; recent products are non-critical.
    }
  };

  const productUrl = (rootUrl, handle, variantId) => {
    const root = rootUrl === '/' ? '' : String(rootUrl || '').replace(/\/$/, '');
    return `${root}/products/${encodeURIComponent(handle)}?variant=${encodeURIComponent(variantId)}`;
  };

  const renderProduct = (product, rootUrl, unavailableLabel) => {
    const link = document.createElement('a');
    link.className = 'lala-search-recent-card';
    link.href = productUrl(rootUrl, product.handle, product.variantId);
    link.dataset.lalaVariantId = product.variantId;
    link.dataset.lalaAvailable = product.available ? 'true' : 'false';

    const media = document.createElement('span');
    media.className = 'lala-search-recent-card__media';

    if (product.image) {
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 280;
      image.height = 280;
      media.append(image);
    }

    const content = document.createElement('span');
    content.className = 'lala-search-recent-card__content';

    const title = document.createElement('span');
    title.className = 'lala-search-recent-card__title';
    title.textContent = product.title;
    content.append(title);

    if (product.price) {
      const price = document.createElement('span');
      price.className = 'lala-search-recent-card__price';
      price.textContent = product.price;
      content.append(price);
    }

    if (product.available === false && unavailableLabel) {
      const availability = document.createElement('span');
      availability.className = 'lala-search-recent-card__availability';
      availability.textContent = unavailableLabel;
      content.append(availability);
    }

    link.append(media, content);
    return link;
  };

  const renderMount = (mount) => {
    const locale = mount.dataset.lalaLocale || document.documentElement.lang || 'de';
    const products = readProducts(locale);
    const section = mount.closest('[data-lala-recent-section]');

    if (!section || products.length === 0) return;

    const fragment = document.createDocumentFragment();
    products.slice(0, 4).forEach((product) => {
      fragment.append(renderProduct(product, mount.dataset.lalaRootUrl || '/', mount.dataset.lalaUnavailableLabel));
    });
    mount.replaceChildren(fragment);
    section.hidden = false;
  };

  const ingestProductNode = (node) => {
    try {
      writeProduct(JSON.parse(node.textContent));
    } catch (error) {
      // Ignore malformed optional tracking data without affecting product purchase flow.
    }
  };

  document.querySelectorAll('[data-lala-recent-product]').forEach(ingestProductNode);

  document.addEventListener('krown:variant:change', (event) => {
    const productPage = event.detail?.productForm?.closest('[data-js-product-component]');
    const productNode = productPage?.querySelector('[data-lala-recent-product]');
    if (productNode) ingestProductNode(productNode);
  });

  document.querySelectorAll('[data-lala-recent-products]').forEach(renderMount);
  window.LalaRecentProducts = { readProducts };
})();
